export default function() {
  const widgetName = 'cardWidgetEvents';
  const widgetOpts = cardWidgetEventsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i, item) {
        if (data.items[i].DateRange) {
          var rawDate = data.items[i].DateRange.slice(0, 7);
          var m = rawDate.slice(0, 4).trim();
          var d = rawDate.replace(",", "").slice(-3).trim();
          $(this).prepend(`
            <div class="card-widget-date">
              <span class="month">${m}</span>
              <span class="month">${d}</span>
            </div>
          `);
        }

        // const eventTitles = $("#cardWidgetEvents .card-widget-title");
        // eventTitles
        // .filter(function() {
        //   return $(this).text().length > 20;
        // })
        // .each(function() {
        //   const titleText = $(this).text();
        //   const truncatedText = titleText.substring(0, 20) + "...";
        //   $(this).text(truncatedText);
        // });
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}